import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=a3fdfcfe&scoped=true&"
var script = {}
import style0 from "./foot.vue?vue&type=style&index=0&id=a3fdfcfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fdfcfe",
  null
  
)

export default component.exports